"use client";

import {
  deserializePermissionsCookie,
  PERMISSIONS_COOKIE_NAME,
} from "@/lib/permissions-cookie";
import useDataStore from "@/stores/data-store";
import { IPathPermission } from "@/types/base-type";
import clsx from "clsx";
import Cookies from "js-cookie";
import { ReactNode, useEffect, useState } from "react";
import { Header } from "@/components/header";
import Sidebar from "@/components/sidebar";

export default function AppShell({
  children,
  modal,
  permissions,
  showAppShell,
}: {
  children: ReactNode;
  modal: ReactNode;
  permissions: IPathPermission[];
  showAppShell: boolean;
}) {
  const { isSidebarCollapsed } = useDataStore();
  const isDevelopment = process.env.NODE_ENV === "development";
  const [resolvedPermissions, setResolvedPermissions] =
    useState<IPathPermission[]>(permissions);
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  useEffect(() => {
    setResolvedPermissions(permissions);

    if (permissions.length > 0) {
      return;
    }

    const permissionsCookie = Cookies.get(PERMISSIONS_COOKIE_NAME);
    const clientPermissions = deserializePermissionsCookie(permissionsCookie);

    if (clientPermissions.length > 0) {
      setResolvedPermissions(clientPermissions);
    }
  }, [permissions]);

  const hasPermissions = resolvedPermissions.length > 0;
  const canShowSidebar = isDevelopment || hasPermissions;

  return (
    <>
      {showAppShell && <Header />}
      {showAppShell && canShowSidebar && (
        <Sidebar permissions={resolvedPermissions} />
      )}
      <div
        className={clsx(
          "app-canvas min-h-screen",
          hasMounted && "transition-[margin] duration-300 ease-out",
          showAppShell && "pb-6 pt-5",
          showAppShell &&
            canShowSidebar &&
            (isSidebarCollapsed ? "lg:ml-[76px]" : "lg:ml-64")
        )}
      >
        <div
          className={clsx(
            "mx-auto w-full",
            hasMounted &&
              "transition-[padding,max-width] duration-300 ease-out",
            showAppShell && "px-5 lg:px-7",
            showAppShell &&
              (canShowSidebar && isSidebarCollapsed
                ? "max-w-[1720px]"
                : "max-w-[1520px]")
          )}
        >
          {children}
          {modal}
        </div>
      </div>
    </>
  );
}
